import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';

function PopOverContent({ overlayId, overlayMessage }) {
  return (
    <Popover id={overlayId}>
      <div className="text-center">{overlayMessage}</div>
    </Popover>
  );
}

function OverlayPopup({ overlayId, overlayMessage, placement, children }) {
  return (
    <OverlayTrigger
      container={this}
      trigger="click"
      rootClose
      placement={placement}
      overlay={PopOverContent({ overlayId, overlayMessage })}
    >
      {children}
    </OverlayTrigger>
  );
}

OverlayPopup.propTypes = {
  overlayId: PropTypes.any.isRequired,
  overlayMessage: PropTypes.any.isRequired,
  placement: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
};

export { OverlayPopup };
